import { render, staticRenderFns } from "./estCostList.vue?vue&type=template&id=670e42df"
import script from "./estCostList.vue?vue&type=script&lang=js"
export * from "./estCostList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports